module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kXu03"))).then(() => parcelRequire('5erN3'));